import { environment } from 'src/environments/environment';
import { NavigationItem } from './navigation-item.model';

export class UserNavigation {
    private items: Array<NavigationItem>;

    constructor(items: NavigationItem[]) {
        this.items = items;
    }

    get Items(): NavigationItem[] { return this.items; }
    set Items(value: NavigationItem[]) { this.items = value; }


    private getNavigationItem(navID: number): NavigationItem {
        let found: NavigationItem;
        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < this.Items.length; index++) {
            const childItem = this.Items[index];
            const item = childItem.getNavigationItem(navID);
            if (item) {
                found = item;
                break;
            }
        }
        return found;
    }

    public getNavigationItemUsingPermID(permID: string): NavigationItem {
        let found: NavigationItem;
        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < this.Items.length; index++) {
            const childItem = this.Items[index];
            const item = childItem.getNavigationItemUsingPerm(permID);
            if (item) {
                found = item;
                break;
            }
        }
        return found;
    }

    public getNavigationItemUsingItemID(itemID: number): NavigationItem {
        let found: NavigationItem;
        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < this.Items.length; index++) {
            const childItem = this.Items[index];
            const item = childItem.getNavigationItemUsingItem(itemID);
            if (item) {
                found = item;
                break;
            }
        }
        return found;
    }

    public getNavigationItemHierarchy(navID: number): NavigationItem[] {
        const hierarchy = new Array<NavigationItem>();
        const navItem = this.getNavigationItem(navID);
        if (navItem) {
            hierarchy.push(navItem);
            const parentId = navItem.ParentID;
            if (parentId) {
                const parentHierarchy = this.getNavigationItemHierarchy(parentId);
                hierarchy.push(...parentHierarchy);
            } else if (parentId === 0) {
                const parentNavItem = this.getNavigationItem(parentId);
                hierarchy.push(parentNavItem);
            }
        }
        return hierarchy;
    }

    public getNavigationItemHierarchyUsingPermID(permItemID: string): NavigationItem[] {
        const hierarchy = new Array<NavigationItem>();
        const navItem = this.getNavigationItemUsingPermID(permItemID);
        if (navItem) {
            hierarchy.push(navItem);
            const parentId = navItem.ParentID;
            if (parentId) {
                const parentHierarchy = this.getNavigationItemHierarchy(parentId);
                hierarchy.push(...parentHierarchy);
            } else if (parentId === 0) {
                const home = hierarchy.find(ni => ni.PermItemID === environment.HomePermId);
                const homeExists = (home) ? true : false;
                if (!homeExists) {
                    const parentNavItem = this.getNavigationItem(parentId);
                    hierarchy.push(parentNavItem);
                }
            }
        }
        return hierarchy;
    }

    public toString(): string {
        const parts = new Array<string>();
        this.Items.forEach(item => {
            const itemString = item.toString();
            const itemParts = itemString.split(';');
            parts.push(...itemParts);
        });
        const fullString = parts.join(';');
        return fullString;
    }
}
